import { render, staticRenderFns } from "./notice-panel.vue?vue&type=template&id=c9e3842c&scoped=true"
import script from "./notice-panel.vue?vue&type=script&lang=js"
export * from "./notice-panel.vue?vue&type=script&lang=js"
import style0 from "./notice-panel.vue?vue&type=style&index=0&id=c9e3842c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e3842c",
  null
  
)

export default component.exports